import React, { Component } from 'react';
import { Menu, Dropdown, Icon } from 'antd';
import barmenu from './images/barmenu.png';

import './css/appbar.css';

export default class BarMenu extends Component{
    render(){
        

        const menu = (
        <Menu>
            <Menu.Item>
            <a href="#home" style={{padding: 20}} >
                Home
            </a>
            </Menu.Item>
            <Menu.Item>
            <a href="#learn" style={{padding: 20}}>
                Learn
            </a>
            </Menu.Item>
            <Menu.Item>
            <a href="#about" style={{padding: 20}}>
                About
            </a>
            </Menu.Item>
            <Menu.Item>
            <a href="#team" style={{padding: 20}}>
                Team
            </a>
            </Menu.Item>
            <Menu.Item>
            <a href="#contact" style={{padding: 20}}>
                Contact
            </a>
            </Menu.Item>
            <Menu.Item>
            <a href="" style={{padding: 20}}>
                Login
            </a>
            </Menu.Item>
        </Menu>
        );

        return(
            <Dropdown overlay={menu} placement="bottomRight" >
                <a className="ant-dropdown-link" href="#">
                    <img src={barmenu} className="bar-menu"/>
                </a>
            </Dropdown>
        );
    }}


// WEBPACK FOOTER //
// ./src/LandingPage/BarMenu.js